export default "__VITE_ASSET__BmVYOz_v__"